// header
'use client';
import { usePathname } from 'next/navigation';
import { useParams } from 'next/navigation';
import useScrollDirection from '@/hook/useScrollDirection';
import { IS_LIST_PATH } from '@/common/constant';

const Header = ({ children }) => {
    const pathname = usePathname();

    const params = useParams();
    const { newsSlug } = params;
    const isListPath = IS_LIST_PATH.includes(pathname) && !newsSlug;
    const scrollDirection = useScrollDirection();

    return (
        <header
            className={`${isListPath ? '' : 'bg-black'} ${
                scrollDirection === 'down' && newsSlug ? 'ulg:top-[-55px]' : 'ulg:top-0'
            } trans ulg:sticky pl-[16px] mx-auto relative w-full z-[21] h-[54px] pr-[30px] py-[9px] between-center ulg:px-[22px] usm:!px-[15px] ulg:gap-x-[10px]
                ulg:border-b-1 ulg:border-black9 ulg:overflow-hidden ulg:bg-black ulg:overflow-x-hidden`}
        >
            {children}
        </header>
    );
};

export default Header;
